export const DEFAULT_COUNTRY_CODE = 'CA';
export const DEFAULT_LOCALE = 'en-CA';

export const COUNTRY_CONFIGS = Object.freeze({
  CA: Object.freeze({
    code: 'CA',
    name: 'Canada',
    locale: 'en-CA',
    currency: 'CAD',
    regionLabel: 'Province or territory',
    regionExample: 'e.g. Alberta',
    taxSystem: 'ca_gst_hst',
    taxLabel: 'GST/HST',
    languageLabel: 'English (Canada)',
    supported: true
  }),
  US: Object.freeze({
    code: 'US',
    name: 'United States',
    locale: 'en-US',
    currency: 'USD',
    regionLabel: 'State',
    regionExample: 'e.g. Colorado',
    taxSystem: 'us_federal_state',
    taxLabel: 'Federal and state/local taxes',
    languageLabel: 'English (United States)',
    supported: true
  })
});

export const ACTIVE_COUNTRIES = Object.freeze(
  Object.values(COUNTRY_CONFIGS).filter((country) => country.supported)
);

const LEGACY_COUNTRY_CODES = Object.freeze({
  Canada: 'CA',
  'United States': 'US'
});

export function getCountryConfig(value = DEFAULT_COUNTRY_CODE) {
  const code = LEGACY_COUNTRY_CODES[value] || value;
  return COUNTRY_CONFIGS[code] || null;
}

export function normalizeBusinessRegion(values = {}) {
  const country = getCountryConfig(values.countryCode || values.country);

  if (!country?.supported) {
    throw new Error('Choose a supported Business country.');
  }

  if (values.currency && values.currency !== country.currency) {
    throw new Error(`Businesses in ${country.name} must use ${country.currency}.`);
  }

  return {
    countryCode: country.code,
    country: country.name,
    currency: country.currency,
    locale: country.locale,
    taxSystem: country.taxSystem,
    province: values.province?.trim() || null
  };
}

export function hasSupportedTaxSystem(business) {
  const country = getCountryConfig(business?.country_code || business?.country);
  return country?.supported === true && (business?.tax_system || country.taxSystem) === country.taxSystem;
}

export function formatBusinessMoney(amount, business = {}) {
  const country = getCountryConfig(business.country_code || business.country) || COUNTRY_CONFIGS.CA;
  return new Intl.NumberFormat(business.locale || country.locale, {
    style: 'currency',
    currency: business.currency || country.currency
  }).format(Number(amount || 0));
}
